/* global graphql */

import React from 'react';
import AOS from 'aos';
import Helmet from 'react-helmet';
import { withPrefix } from 'gatsby-link';

import Features from '../../components/features';
import HowTo from '../../components/how-to';

import './_pricing.scss';

class PricingPage extends React.Component {

  constructor(props) {
    super(props);
  }

  //==============
  // React Methods
  //==============

  componentDidMount() {
    const isBrowser = typeof window !== 'undefined';
    const AOS = isBrowser ? require('aos') : undefined;
    this.aos = AOS;
    this.aos.init();
  }

  componentDidUpdate() {
    this.aos.refresh();
  }

  //==============
  // Click Events
  //==============

  loadArticle() {
    console.log('loaded article');
    window.open('https://medium.com/@GetFirstStep/getting-students-ahead-of-the-game-a7a5b987de8a');
  }

  //=================
  // Render Component
  //=================

  render() {
    return (
      <div>
        <Helmet>
          <title>Pricing | The investment account of the future</title>
          <meta name="description" content="Save with confidence, not high fees. No brokerage. No upfront fees. Cancel anytime" />
        </Helmet>
        <section class="simple-pricing" data-aos="fade-up" data-aos-once>
          <div class="wrapper">
            <div class="inner-wrapper">
              <div class="title">
                <h1>Simple pricing that works for everyone</h1>
                <p>Save with confidence, not high fees.<br /> No brokerage. No  upfront fees. Cancel anytime</p>
              </div>
            </div>
          </div>
        </section>
        <section class="pricing-switch" data-aos="fade-up" data-aos-once>
          <div class="wrapper">
            <div class="inner-wrapper">
              <div class="row align-items-center justify-content-center">
                <div class="col-12 col-sm-5">
                  <div class="price-thumb">
                    <h2>$1.25<span>per month</span></h2>
                    <p>for accounts under $5,500</p>
                    <span class="note">$1.95 per month for Direct Debit</span>
                  </div>
                </div>
                <div class="col-12 col-sm-1 text-center">
                  <span class="option-text">or</span>
                </div>
                <div class="col-12 col-sm-5">
                  <div class="price-thumb">
                    <h2>0.275%<span>a year</span></h2>
                    <p>for accounts over $5,500</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="what-get" data-aos="fade-up" data-aos-once>
          <div class="wrapper">
            <div class="inner-wrapper">
              <h2 class="text-center">What you get from us</h2>
              <div class="row">
                <div class="col-md-6">
                  <div class="item">
                    <div class="check">
                      <img src={withPrefix('/images/icons/icon-tick.svg')} alt="Feature icon" />
                    </div>
                    <div class="info">
                      <h4>Low minimums</h4>
                      <p>Get started with as little as $1.</p>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="item">
                    <div class="check">
                      <img src={withPrefix('/images/icons/icon-tick.svg')} alt="Feature icon" />
                    </div>
                    <div class="info">
                      <h4>Bank grade security</h4>
                      <p>All sensitive data is secured using 256-bit encryption.</p>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="item">
                    <div class="check">
                      <img src={withPrefix('/images/icons/icon-tick.svg')} alt="Feature icon" />
                    </div>
                    <div class="info">
                      <h4>Save effortlessly</h4>
                      <p>Automatically save for your goals.</p>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="item">
                    <div class="check">
                      <img src={withPrefix('/images/icons/icon-tick.svg')} alt="Feature icon" />
                    </div>
                    <div class="info">
                      <h4>Investing themes</h4>
                      <p>We offer ETFs that let you invest by theme in industries, causes, and strategies.</p>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="item">
                    <div class="check">
                      <img src={withPrefix('/images/icons/icon-tick.svg')} alt="Feature icon" />
                    </div>
                    <div class="info">
                      <h4>Make investing automatic</h4>
                      <p>Create a saving plan so you can make investing a habit over the long run.</p>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="item">
                    <div class="check">
                      <img src={withPrefix('/images/icons/icon-tick.svg')} alt="Feature icon" />
                    </div>
                    <div class="info">
                      <h4>Learn as you go</h4>
                      <p>Tips, guides and lessons to help you grow your savings with confidence.</p>
                    </div>
                  </div>
                </div>
                {/* <div class="col-md-6">
                    <div class="item">
                      <div class="check">
                        <img src={withPrefix('/images/icon-tick.svg')}/>
                      </div>
                      <div class="info">
                        <h4>Save effortlessly</h4>
                        <p>Automatically save for your goals and save more amount easily</p>
                      </div>
                    </div>
                  </div>                   */}
              </div>
            </div>
          </div>
        </section>

        <div class="container">
          <section class="content-block text-center special-offer" data-aos="fade-up" data-aos-once>
            <div class="row">
              <div class="col-12">
                <h2>Students + FirstStep = 😍</h2>
                <p>Students, you may not have a lot to save right now, but what you have is time - your greatest asset. With time you can make use of compound interest - essentially, interest on interest.</p>
                <p>Sign up with your student email and recieve the first 3 months free!</p>
                <button onClick={this.loadArticle} type="button" class="btn btn-pink-gradient">Get 3 months free</button>
              </div>
            </div>
          </section>
        </div>




        {/* <section class="special-offer" data-aos="fade-up" data-aos-once>
            <div class="wrapper">
              <div class="inner-wrapper text-center">
                <h2 class="text-center"></h2>
                <p class="text-center">Students, you may not have a lot to save right now, but what you have is time - your greatest asset. With time you can make use of compound interest - essentially, interest on interest.</p>
                <p class="text-center">Sign up with your student email and recieve the first 3 months free.</p>
                <button onClick={this.loadArticle} type="button" class="btn btn-pink-gradient">Get 3 months free</button>
              </div>
            </div>
          </section> */}
      </div>
    );
  }
}

export default PricingPage;



// WEBPACK FOOTER //
// ./src/pages/pricing/index.js